import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["title", "unit", "value"];
  static values = {
    id: String,
    included: Boolean,
    regionToHighlight: Object,
    url: String
  };

  hover() {
    this.dispatch("hovered", {
      prefix: "observation",
      detail: {
        regionToHighlight: this.regionToHighlightValue
      }
    })
  }

  updateIgnoredStatus({ detail: { content } }) {
    this.includedValue = content;

    const parameters = {
      discard: !this.includedValue,
    };
    return this._sendRequest(parameters);
  }

  update() {
    const parameters = {
      observation: {
        title: this.titleTarget.value,
        unit: this.unitTarget.value,
        value: this.valueTarget.value,
      },
    };
    return this._sendRequest(parameters);
  }

  async _sendRequest(parameters) {
    const request = new FetchRequest("PUT", this.urlValue, {
      body: JSON.stringify(parameters),
    });
    const response = await request.perform();

    if (response.ok) {
      const body = await response.text;
      Turbo.renderStreamMessage(body);
    }
  }
}
